var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 1.33333C10.5267 1.33333 12.7801 2.75333 13.8801 5C12.7801 7.24667 10.5267 8.66667 8.00008 8.66667C5.47341 8.66667 3.22008 7.24667 2.12008 5C3.22008 2.75333 5.47341 1.33333 8.00008 1.33333ZM8.00008 0C4.66675 0 1.82008 2.07333 0.666748 5C1.82008 7.92667 4.66675 10 8.00008 10C11.3334 10 14.1801 7.92667 15.3334 5C14.1801 2.07333 11.3334 0 8.00008 0ZM8.00008 3.33333C8.92008 3.33333 9.66675 4.08 9.66675 5C9.66675 5.92 8.92008 6.66667 8.00008 6.66667C7.08008 6.66667 6.33341 5.92 6.33341 5C6.33341 4.08 7.08008 3.33333 8.00008 3.33333ZM8.00008 2C6.34675 2 5.00008 3.34667 5.00008 5C5.00008 6.65333 6.34675 8 8.00008 8C9.65341 8 11.0001 6.65333 11.0001 5C11.0001 3.34667 9.65341 2 8.00008 2Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.f43b0fb6e35f82cf3cec22bf1604cf3e.svg";
export { ForwardRef as ReactComponent };